<template>
  <el-dialog class="user_model_dialog" top="5vh" center :title="newTitle" :append-to-body="true" width="70%" :before-close="handleClose"
             :visible.sync="dialogVisible" :close-on-click-modal="false">
    <el-form v-loading="loading.dialog" size="mini" ref="form" :rules="rules" :model="form">
      <div >
        <el-form-item  label="类别" prop="work_type" :label-width="formLabelWidth">
            <el-select  filterable clearable collapse-tags size="mini" v-model="form.work_type"  placeholder="请选择">
              <el-option v-for="(key, value) in types" :key="key" :label="key" :value="value" />
            </el-select>
          <el-tooltip class="item" effect="dark" content="新增类别" placement="top">
            <span @click="dialogVisibleAddDataCateGory = true"  class="el-icon-plus addDataCategory">新增类别</span>
          </el-tooltip>
        </el-form-item>
        <el-form-item  label="名称" prop="module_value" :label-width="formLabelWidth" style="width: 50%;">
          <el-input v-model="form.module_value" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status" :label-width="formLabelWidth" >
          <el-switch v-model="form.status" active-color="#11a983" inactive-color="#f5f7fa" active-value="1" inactive-value="0">
          </el-switch>
        </el-form-item>
      </div>
      <div style="display: flex;">
<!--        <el-form-item  label="创建人" prop="ownerId" :label-width="formLabelWidth" style="width:50%;">-->
<!--          <el-select  filterable collapse-tags size="mini" v-model="form.ownerId" :disabled="!isEdit"  placeholder="请选择负责人">-->
<!--            <el-option v-for="(key, value) in allUser" :key="key" :label="key" :value="value" />-->
<!--          </el-select>-->
<!--        </el-form-item>-->
<!--        <el-form-item v-if="form.id" label="创建时间" prop="createTime" :label-width="formLabelWidth" style="width:40%;">-->
<!--          <el-input v-model="form.create_time"  :disabled="true" autocomplete="off">-->
<!--          </el-input>-->
<!--        </el-form-item>-->
      </div>
<!--      <el-form-item label="成员" prop="teamMates" :label-width="formLabelWidth" label-position="left">-->
<!--        <el-select  filterable  clearable multiple size="mini" v-model="form.teamMates"  placeholder="请选择人员" :disabled="!isEdit"  style="width: 80%">-->
<!--          <el-option v-for="(key, value) in allUser" :key="key" :label="key" :value="value" />-->
<!--        </el-select>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="备注" prop="remarks" :label-width="formLabelWidth" style="width:80%;">-->
<!--        <el-input type="textarea" rows="3" v-model="form.remark" autocomplete="off" placeholder="备注" :disabled="!isEdit"/>-->
<!--      </el-form-item>-->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button  :loading="loading.submit" type="primary"  @click="onSubmit">保存</el-button>
      <el-button type="success" @click="handleClose">关 闭</el-button>
    </div>

    <el-dialog center :append-to-body="true" title="新增类别" :visible.sync="dialogVisibleAddDataCateGory" width="40%" :close-on-click-modal="false" class="DialogDataCategory">
      <el-form :model="DataCategoryForm" :rules="DataCategoryRules" ref="DataCategoryForm" >
        <el-form-item label="类别名称" prop="desc" label-width="80px" >
          <el-input  v-model="DataCategoryForm.desc" autocomplete="off">
          </el-input>
        </el-form-item>
        <div style="margin:0 auto;text-align: center">
          <el-button size="small" type="primary" @click="onAddDataCateGory" :loading="loading.addDataCategoryLoad">确 定</el-button>
          <el-button size="small" @click="dialogVisibleAddDataCateGory = false">取 消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </el-dialog>
</template>
<script>
import { formatEnToUtf8, formatTimeToDate } from "@/views/tops/devOps/components/util.js";
import {
  getDevOpsSpaceDictionariesTypeListlApi,
  getDevOpsSpaceTeamDetaililApi,
  getDevOpsSpaceUserDetailApi,
  getDevOpsSpaceUserRoleListApi,
  postDevOpsSpaceAddTeamApi,
  postDevOpsSpaceCreateDemandApi, postDevOpsSpaceCreateDictionariesTypeApi, postDevOpsSpaceCreateSystemApi,
  postDevOpsSpaceEditDemandApi, postDevOpsSpaceUpdateTeamApi,
  postDevOpsSpaceUpdateUserApi, postDevOpsSpaceUpdateWorderOederTypeApi
} from "@/server/tops/devOps";
import { mapState } from "vuex";
import {getDevOpsSpaceAllUserListApi} from "@/server/tops/base";
export default {
  components: {},
  props: {
    formInfo: {
      type: Object,
      default: function () {
        return {}
      },
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
    showDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
    isEdit:{
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      form: {
        module_value: '',
        status: '1',
        work_type: '',
      },
      rules: {
        module_value: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        status: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        work_type: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
      },
      DataCategoryForm:{
        desc:'',
      },
      DataCategoryRules:{
        desc: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
      },
      dialogVisibleAddDataCateGory:false,
      formLabelWidth: '135px',
      loading: {
        dialog: false,
        submit: false,
        addDataCategoryLoad:false,
      },
      allRoles: [],
      allUser:[],
      types:[],
    };
  },
  async mounted() {
    const { key = '',type = '',state = '',value ="",is_update = ''} = this.formInfo;
    const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
    const userId = this.$store.state.devOps.userInfo.userId? this.$store.state.devOps.userInfo.userId : '';
    this.$set(this.form, 'username', username)
    this.username = username;
    this.$nextTick(async () => {
      await this.getDevOpsSpaceAllUser();
      await this.getDictionariesTypeList();
      if(is_update) {
        this.form = { ...this.form, work_type:type.toString(), module_value:value,status:state.toString()}
      }
    })
  },
  computed: {
    ...mapState(
        {
          allSelect: (state) => state.devOps.ALLSELECT,
        }
    ),
    // 部分不可编辑
    isProjectDisabled() {
      return true;
    },
    newTitle() {
      if (this.form.id) {
        return '编辑数据';
      } else {
        return '新增数据'
      }
    },
    isEditOrCreate(){
      if(!this.form.id){
        return false;
      }
      if(this.isEdit){
        return this.isEdit;
      }

      return false;
    },
  },
  methods: {
    getDate() {
      var now = new Date().getTime();
      return now;
    },
    changeSwitch(v){
      console.log(v);
    },
    async getDevOpsSpaceAllUser(){
      const ret = await getDevOpsSpaceAllUserListApi();
      let arr = {};
      if(ret.status === 'success'){
        ret.data.forEach((item,index)=>{
          if(item.user_type !== 1 && item.user_type !== 13){
            arr[item.id] = item.user_name;
          }
        });
      }
      this.allUser = arr;
    },
    async getDictionariesTypeList() {
      const ret = await getDevOpsSpaceDictionariesTypeListlApi();
      let arr = {};
      if(ret.status === 'success'){
        ret.data.forEach((item,index)=>{
            arr[item.type] = item.desc;
        });
      }
      this.types = arr;
    },
    // 获取详情
    async init(id) {
      this.loading.dialog = true
      try {
        const ret = await getDevOpsSpaceTeamDetaililApi({ id });
        const info = ret.data[0] || {};
        this.form = {
          ...this.form,
          ...info,
          status: info.status.toString(),
          teamMates: info.teamMates ? info.teamMates.split(',') : [],
          ownerId: info.owner_id ? info.owner_id.toString() : '',
        }
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        })
      } finally {
        this.loading.dialog = false
      }

    },
    // 提交
    async onSubmit(close = true) {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.moduleSubmit(close)
        }
      });
    },
    async moduleSubmit(close = true){
      try {
        close && this.$set(this.loading, 'submit', true)
        // const {
        //   name = "",
        //   ownerId = "",
        //   teamMates = [],
        //   remark = '',
        //   status = '',
        //   id = '',
        // } = this.form;
        const param = this.form;
        // key 存在 更新 不存在 创建
        const ret = this.formInfo.is_update ? await postDevOpsSpaceUpdateWorderOederTypeApi({work_key: this.formInfo.key,type:param.work_type,value:param.module_value,state:param.status }) : await postDevOpsSpaceCreateSystemApi(param);
        if (ret.status === 'success') {
          this.$notify({
            message: ret.message || '提交成功',
            type: "success",
          })
          setTimeout(() => {
            this.handleClose()

          }, 500)
        } else {
          this.$notify({
            message: ret.message || "失败",
            type: "error",
          })
        }
      } catch (error) {
        this.$notify({
          message: error || "网络错误",
          type: "error",
        })
      } finally {
        this.loading.submit = false;
      }
    },
    onAddDataCateGory(){
      this.$refs["DataCategoryForm"].validate(async (valid) => {
        if (valid) {
          try {
            this.$set(this.loading, 'addDataCategoryLoad', true);
            const ret =  await postDevOpsSpaceCreateDictionariesTypeApi(this.DataCategoryForm);
            if (ret.status === 'success') {
              this.dialogVisibleAddDataCateGory = false;
              this.loading.addDataCategoryLoad =  false;
              await this.getDictionariesTypeList();
              this.$notify({
                message: ret.message || "成功",
                type: "success",
              })
            } else {
              this.loading.addDataCategoryLoad =  false;
              this.$notify({
                message: ret.message || "失败",
                type: "error",
              })
            }
          } catch (error) {
            this.loading.addDataCategoryLoad =  false;
            this.$notify({
              message: error || "网络错误",
              type: "error",
            })
          } finally {
            this.loading.addDataCategoryLoad =  false;
          }
        }

      })
    },
    // 关闭弹窗
    handleClose(step) {
      this.hideDialogVisible(step)
    },
    // 将多个英文名转换为中文
    formatEnToUtf8,
    formatTimeToDate,
  }
};
</script>
<style lang="scss">
.user_model_dialog {
  .comment_warp {
    .comment_item>div {
      display: flex;
      margin: 0;
      margin-bottom: 12px;

      .el-textarea__inner {
        font-weight: bold;
      }
    }
  }

  .table_text_click {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .table_text_no_click {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .el-dialog__body {
    padding-bottom: 0;
  }
  .el-form-item__content {
    line-height: 16px;
  }
  .el-form-item__label {
    font-weight: bold;
    font-size: 12px;
  }
}

.popperDom {
  max-width: 240px;
}
.addDataCategory{
  margin-left: 10px;
  color: rgb(64, 158, 255);
  cursor: pointer;
  border: 1px solid;
  padding: 5px 10px;
  border-radius: 10px;
  font-size: 12px;
}
.DialogDataCategory .el-form-item__label{
  font-size: 12px;
  font-weight: bold;
}
.DialogDataCategory .el-input__inner{
  height: 30px;
}
</style>
